var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55211 17.5734C9.41877 17.5734 9.29377 17.5526 9.17711 17.5109C9.06044 17.4693 8.95211 17.3984 8.85211 17.2984L4.55211 12.9984C4.36877 12.8151 4.28127 12.5776 4.28961 12.2859C4.29794 11.9943 4.39377 11.7568 4.57711 11.5734C4.76044 11.3901 4.99377 11.2984 5.27711 11.2984C5.56044 11.2984 5.79377 11.3901 5.97711 11.5734L9.55211 15.1484L18.0271 6.67344C18.2104 6.4901 18.4479 6.39844 18.7396 6.39844C19.0313 6.39844 19.2688 6.4901 19.4521 6.67344C19.6354 6.85677 19.7271 7.09427 19.7271 7.38594C19.7271 7.6776 19.6354 7.9151 19.4521 8.09844L10.2521 17.2984C10.1521 17.3984 10.0438 17.4693 9.92711 17.5109C9.81044 17.5526 9.68544 17.5734 9.55211 17.5734Z",
    fill: "#188DED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.0f5e9ecaba755bb2d6b7ec8b3cc6d08e.svg";
export { ForwardRef as ReactComponent };